import React from "react";

const title = ({ name }) => {
  return (
    <div className="margin-top-40">
      <h1>{name}</h1>
      <div className="whiteLine" />
    </div>
  );
};

export default title;
